import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

export default function CoworkerCustomerFinanceMenu({
  openItem = null,
  activeItem = null,
}) {
  return (
    <li
      className={`nav-item has-treeview 
          ${sidebarHelper.checkOpenItem(
            openItem,
            "coworker-customer-finance"
          )} `}
    >
      <a
        href="# "
        style={{ fontSize: "14px" }}
        className={`nav-link  
          ${sidebarHelper.checkActiveItem(
            openItem,
            "coworker-customer-finance"
          )} `}
      >
        <i className="nav-icon hl-view-user "></i>
        <p>
          مدیریت مالی کاربران
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/finance/transaction"
            className={`nav-link  
              ${sidebarHelper.checkActiveItem(
                activeItem,
                "all-transaction-coworker-customer"
              )} `}
          >
            <i className="hl-cart-arrows nav-icon"></i>
            <p>انتقال اعتبار</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/finance/pledge/select-customer"
            className={`nav-link  
                ${sidebarHelper.checkActiveItem(
                  activeItem,
                  "all-pledge-for-customer"
                )} `}
          >
            <i class="hl-money-down-arrows nav-icon"></i>
            <p>لیست بیعانه </p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
